/**
 * @generated SignedSource<<a70ab5eb2562c238c8b5fd6402054464>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type userRootNodes_RefetchQuery$variables = {
  name?: string | null;
  userId: string;
};
export type userRootNodes_RefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"userRootNodes_QueryFragment">;
};
export type userRootNodes_RefetchQuery = {
  response: userRootNodes_RefetchQuery$data;
  variables: userRootNodes_RefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "name"
  },
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v6 = [
  (v2/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startedAt",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "definitionType",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "userRootNodes_RefetchQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "userRootNodes_QueryFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "userRootNodes_RefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LearnV2AdminSchema",
            "kind": "LinkedField",
            "name": "LearnV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "RootNodesWithTreeStateType",
                "kind": "LinkedField",
                "name": "RootNodesWithTreeStatesForUser",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LearnOpportunityV2",
                    "kind": "LinkedField",
                    "name": "rootNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "structureDefinition",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "extension",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "unlockInfo",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v5/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "firstContentId",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "firstContentCoordinatesIndexPath",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "UnlockInfoDemo",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "PublishedRootExtensionImpl",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "LearnOpportunityRootStructureDefinition",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeState",
                    "kind": "LinkedField",
                    "name": "treeState",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "definition",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TreeNode",
                                "kind": "LinkedField",
                                "name": "headContentNode",
                                "plural": false,
                                "selections": (v6/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "StartedTreeStateDefinition",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "progressPercentage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TreeNode",
                        "kind": "LinkedField",
                        "name": "rootNode",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "parentId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "structureDefinition",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CoordinatesV2",
                                "kind": "LinkedField",
                                "name": "coordinates",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "parentRef",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v9/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "typeDefinition",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v9/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "childRefs",
                                    "storageKey": null
                                  }
                                ],
                                "type": "BranchTypeDefinition",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "contentKind",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "elements",
                                        "plural": true,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v2/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "elementType",
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isElementV2"
                                          },
                                          (v4/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "question",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "MultipleChoiceElementV2",
                                            "abstractKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "ELearningContentTypeDefinition",
                                    "abstractKey": null
                                  }
                                ],
                                "type": "ContentTypeDefinition",
                                "abstractKey": "__isContentTypeDefinition"
                              }
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "extension",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TreeUnlockedState",
                                "kind": "LinkedField",
                                "name": "treeUnlockedState",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "data",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v5/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "User",
                                            "kind": "LinkedField",
                                            "name": "unlockedByUser",
                                            "plural": false,
                                            "selections": [
                                              (v2/*: any*/),
                                              (v7/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "UnlockedByAdmin",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "License",
                                            "kind": "LinkedField",
                                            "name": "license",
                                            "plural": false,
                                            "selections": [
                                              (v2/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "creationInfo",
                                                "plural": false,
                                                "selections": [
                                                  (v3/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "LicenseDefinition",
                                                    "kind": "LinkedField",
                                                    "name": "licenseDefinition",
                                                    "plural": false,
                                                    "selections": [
                                                      (v2/*: any*/),
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": null,
                                                        "kind": "LinkedField",
                                                        "name": "data",
                                                        "plural": false,
                                                        "selections": [
                                                          (v3/*: any*/),
                                                          (v7/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "UnlockedByLicense",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "when",
                                    "storageKey": null
                                  },
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContentSubmission",
                                "kind": "LinkedField",
                                "name": "submissions",
                                "plural": true,
                                "selections": [
                                  (v2/*: any*/),
                                  (v8/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "lastUpdated",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LearnOpportunityV2",
                                    "kind": "LinkedField",
                                    "name": "learnOpportunity",
                                    "plural": false,
                                    "selections": (v6/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "GamificationPointsReceivedByContent",
                                "kind": "LinkedField",
                                "name": "gamificationPoints",
                                "plural": true,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "contentId",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "num",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "TkaTreeStateExtension",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f47d348f2d6c4d7df80eed4079a6216e",
    "id": null,
    "metadata": {},
    "name": "userRootNodes_RefetchQuery",
    "operationKind": "query",
    "text": "query userRootNodes_RefetchQuery(\n  $name: String\n  $userId: ID!\n) {\n  ...userRootNodes_QueryFragment_1qiuzi\n}\n\nfragment ElementNode_ElementV2Fragment on ElementV2 {\n  __isElementV2: __typename\n  id\n  title\n  ... on MultipleChoiceElementV2 {\n    question\n  }\n  elementType\n}\n\nfragment createTreeStateButton_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  id\n  structureDefinition {\n    __typename\n    title\n  }\n}\n\nfragment editLearnStartDateButton_TreeStateFragment on TreeState {\n  id\n  startedAt\n}\n\nfragment reenablePaywallButton_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  id\n  structureDefinition {\n    __typename\n    title\n  }\n}\n\nfragment resetLearnProgressButton_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  id\n  structureDefinition {\n    __typename\n    title\n  }\n}\n\nfragment treeUnlockedStateDisplay_TreeUnlockedStateFragment on TreeUnlockedState {\n  when\n  data {\n    __typename\n    kind\n    ... on UnlockedByAdmin {\n      unlockedByUser {\n        id\n        name\n      }\n    }\n    ... on UnlockedByLicense {\n      license {\n        id\n        creationInfo {\n          __typename\n          licenseDefinition {\n            id\n            data {\n              __typename\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment unlockTreeButton_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  id\n  structureDefinition {\n    __typename\n    title\n  }\n}\n\nfragment userRootNodeItem_LearnOpportunityV2Fragment on LearnOpportunityV2 {\n  id\n  structureDefinition {\n    __typename\n    title\n    ... on LearnOpportunityRootStructureDefinition {\n      extension {\n        __typename\n        ... on PublishedRootExtensionImpl {\n          unlockInfo {\n            __typename\n            kind\n            ... on UnlockInfoDemo {\n              firstContentId\n              firstContentCoordinatesIndexPath\n              kind\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment userRootNodeItem_RootNodesWithTreeStateTypeFragment on RootNodesWithTreeStateType {\n  rootNode {\n    ...userRootNodeItem_LearnOpportunityV2Fragment\n    ...reenablePaywallButton_LearnOpportunityV2Fragment\n    ...resetLearnProgressButton_LearnOpportunityV2Fragment\n    ...createTreeStateButton_LearnOpportunityV2Fragment\n    ...unlockTreeButton_LearnOpportunityV2Fragment\n    id\n  }\n  treeState {\n    ...userRootNodeItem_TreeStateFragment\n    ...editLearnStartDateButton_TreeStateFragment\n    id\n  }\n}\n\nfragment userRootNodeItem_TreeStateFragment on TreeState {\n  id\n  definition {\n    __typename\n    status\n    ... on FinishedTreeStateDefinition {\n      status\n    }\n    ... on StartedTreeStateDefinition {\n      status\n      headContentNode {\n        id\n      }\n    }\n  }\n  user {\n    name\n    id\n  }\n  startedAt\n  progressPercentage\n  rootNode {\n    parentId\n    structureDefinition {\n      __typename\n      coordinates {\n        parentRef\n      }\n      definitionType\n      title\n    }\n    typeDefinition {\n      __typename\n      definitionType\n      ... on BranchTypeDefinition {\n        childRefs\n      }\n      ... on ContentTypeDefinition {\n        __isContentTypeDefinition: __typename\n        contentKind\n        ... on ELearningContentTypeDefinition {\n          elements {\n            __typename\n            id\n            elementType\n            ...ElementNode_ElementV2Fragment\n          }\n        }\n      }\n    }\n    id\n  }\n  extension {\n    __typename\n    ... on TkaTreeStateExtension {\n      treeUnlockedState {\n        data {\n          __typename\n          kind\n        }\n        ...treeUnlockedStateDisplay_TreeUnlockedStateFragment\n        id\n      }\n      submissions {\n        id\n        startedAt\n        lastUpdated\n        learnOpportunity {\n          id\n        }\n      }\n      gamificationPoints {\n        id\n        contentId\n        num\n      }\n    }\n  }\n}\n\nfragment userRootNodes_QueryFragment_1qiuzi on Query {\n  Admin {\n    LearnV2 {\n      RootNodesWithTreeStatesForUser(userId: $userId, name: $name) {\n        rootNode {\n          id\n        }\n        ...userRootNodeItem_RootNodesWithTreeStateTypeFragment\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a929b59864d87d1cfff92065d9e68d18";

export default node;
